



















































import { computed, defineComponent, ref, getCurrentInstance } from '@vue/composition-api';
import { DownloadIcon } from 'tdesign-icons-vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { IS_BROWSER } from '@/common/constant/platform';
import { exportExcelInBrowser, exportExcelInPC, phoneCompose } from '@/renderer/scripts/utils/tools/index';
import { getDownloadPath } from '@/renderer/scripts/utils/download/downloadHelper';
import SMHErrorCodeMap from '@/renderer/scripts/utils/errorCode/smhErrorCodeMap';

export default defineComponent({
  components: {
    DownloadIcon,
  },
  props: {
    result: Object,
    syncType: {
      required: true,
      type: String,
      default: '',
    },
  },
  filters: {
    FormatErrorMsg(code: string) {
      return SMHErrorCodeMap[code] || code;
    },
    FormatTab(val: string) {
      const map: Record<string, string> = {
        user: i18n_t('成员'),
        team: i18n_t('团队'),
      };
      return map[val];
    },
  },
  setup(props, context) {
    const tabVal = ref('user');
    const total = computed(() => {
      if (props.syncType === 'yufu') {
        return (tabVal.value === 'user' ? props.result?.yufuUserCount : props.result?.yufuTeamCount) || 0;
      }
      if (props.syncType === 'wework') {
        return (tabVal.value === 'user' ? props.result?.weworkUserCount : props.result?.weworkTeamCount) || 0;
      }
      if (['openLdap', 'windowsAd', 'supwisdom'].includes(props.syncType)) {
        return (tabVal.value === 'user' ? props.result?.userCount : props.result?.departmentCount) || 0;
      }
    });
    const errList = computed(() => {
      const result = props.result?.failedItems?.filter((item: any) => item.type === tabVal.value) || [];
      return result;
    });
    const columns = computed(() => {
      let userColumns = [
        { colKey: 'name', title: i18n_t('姓名'), width: 80, ellipsis: true },
        { colKey: 'phoneNumber', title: i18n_t('手机号'), width: 80, ellipsis: true },
        { colKey: 'departmentPath', title: i18n_t('所属团队'), width: 170, ellipsis: true },
        { colKey: 'code', title: i18n_t(' 失败原因'), width: 170, ellipsis: true },
      ];

      let teamColumns = [
        { colKey: 'weworkDepartmentName', title: i18n_t('团队名'), width: 100, ellipsis: true },
        { colKey: 'code', title: i18n_t(' 失败原因'), width: 210, ellipsis: true },
      ];

      // if (props.syncType === 'yufu') {
      // }
      if (['openLdap', 'windowsAd', 'supwisdom'].includes(props.syncType)) {
        teamColumns = [
          { colKey: 'accountDepartmentName', title: i18n_t('团队名'), width: 100, ellipsis: true },
          { colKey: 'code', title: i18n_t(' 失败原因'), width: 210, ellipsis: true },
        ];

        userColumns = [
          { colKey: 'accountUserName', title: i18n_t('姓名'), width: 80, ellipsis: true },
          { colKey: 'phoneNumber', title: i18n_t('手机号'), width: 80, ellipsis: true },
          { colKey: 'departmentPath', title: i18n_t('所属团队'), width: 170, ellipsis: true },
          { colKey: 'code', title: i18n_t(' 失败原因'), width: 170, ellipsis: true },
        ];
      }
      return tabVal.value === 'user' ? userColumns : teamColumns;
    });
    const methods = {
      async exportErrList() {
        const exportColumns = columns.value.map(item => item.title);
        const exportRecords: any[] = [];
        errList.value.forEach((item: any) => {
          const userArr = [
            item.name || item.accountUserName || '',
            item.phoneNumber || '',
            item.departmentPath || '',
            SMHErrorCodeMap[item.code] || item.code,
          ];

          const teamArr = [
            item.weworkDepartmentName || item.accountDepartmentName || '',
            SMHErrorCodeMap[item.code] || item.code,
          ];

          exportRecords.push(tabVal.value === 'user' ? userArr : teamArr);
        });
        if (IS_BROWSER) {
          exportExcelInBrowser(exportColumns, exportRecords, i18n_t('企业网盘架构同步失败列表.xlsx'));
        } else {
          const downloadPath = await getDownloadPath();
          if (!downloadPath) return;
          exportExcelInPC(exportColumns, exportRecords, i18n_t('企业网盘架构同步失败列表.xlsx'), downloadPath);
        }
      },
      onClose() {
        tabVal.value = 'user';
      },
    };
    return {
      columns,
      total,
      tabVal,
      errList,
      ...methods,
      phoneCompose,
    };
  },
});
